module.exports = __webpack_public_path__ + "img/jinp (3).bcc67e28.jpg";